module.exports = __webpack_public_path__ + "img/harry_potter_03_and_the_prisoner_of_azkaban.0c8b3ed2.jpg";